import React from "react";

import { useContentContext } from "../../context/content-context";
import Box from "../../components/base/box";

// TODO: combine w patient BasicHero?
const BasicHero = () => {
  const {
    pageTitle,
    headerImageDesktop,
    headerImageTablet,
    headerImageMobile,
  } = useContentContext();

  if (pageTitle) {
    return (
      <Box
        as="section"
        className="basic-hero hcp section-outer"
        backgroundImage={[
          `url(${headerImageMobile})`,
          `url(${headerImageTablet})`,
          `url(${headerImageDesktop})`,
        ]}
      >
        <div className="section-inner">
          <h1 className="blue">{pageTitle}</h1>
        </div>
      </Box>
    );
  }

  return null;
};

export default BasicHero;
